import { render, staticRenderFns } from "./SubLearningOutcomeSubTree.vue?vue&type=template&id=327443d7&"
import script from "./SubLearningOutcomeSubTree.vue?vue&type=script&lang=js&"
export * from "./SubLearningOutcomeSubTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports